import { Spinner } from "react-bootstrap";

const Loader = () => (
    <div style={{
        position: "fixed",
        top: 0, left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255,255,255,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000
    }}>
        <Spinner animation="border" variant="warning" />
    </div>
);

export default Loader;